const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDigestiveSurgery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M26.392,27.979H6.734 c-1.086,0-1.966-0.88-1.966-1.966V6.355c0-1.086,0.88-1.966,1.966-1.966h19.658c1.086,0,1.966,0.88,1.966,1.966v19.658 C28.358,27.099,27.478,27.979,26.392,27.979z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD3C5",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M17.507,7.462h-1.784 c0,0-1.393,1.349,1.219,6.354c0,0,1.654,3.351-1.697,4.526c0,0-2.002,0.827-4.222-0.348c-2.219-1.175-3.917,0.392-3.83,2.394 c0.087,2.002,1.436,3.699,1.436,3.699l1.088-0.74c0,0-1.741-1.958-1.132-3.221s1.697,0.348,1.697,0.348s2.219,4.004,7.007,4.047 c0,0,7.78,0.178,8.225-8.312c0.468-8.911-5.832-6.31-5.832-6.31S17.6,10.944,17.426,9.29C17.426,9.29,17.377,8.463,17.507,7.462z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M21.602,11.046c0,0,0.15,0.108,0.366,0.334"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10,
      strokeDasharray: "1.0134,1.0134"
    },
    d: " M22.584,12.181c0.753,1.214,1.463,3.448,0.154,6.928c0,0-1.487,2.939-5.295,3.378"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M16.931,22.53 c-0.163,0.009-0.33,0.013-0.5,0.012"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M17.764,14.281l5.295,0.734 c0,0-0.405,1.421-1.889,1.027l-1.724-0.289l-0.591-0.448l-1.69-0.182l-0.82-0.28l0.339-0.476L17.764,14.281z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: "18.458,14.103 9.594,12.893  9.4,14.316 17.765,15.458  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigestiveSurgery);
export default __webpack_public_path__ + "static/media/digestive_surgery.2d9ee979b402358fe3d43954b9060c78.svg";
export { ForwardRef as ReactComponent };